// Components/common/NotAllowed.jsx

import React from "react";
import { ShieldX, ArrowLeft, LifeBuoy } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function NotAllowed() {

  const navigate = useNavigate();

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">

      <div className="w-full max-w-lg rounded-2xl border border-green-100 bg-white shadow-sm p-8 text-center">

        {/* Icon */}
        <div className="mx-auto mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-red-50">
          <ShieldX
            size={42}
            className="text-red-500"
          />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900">
          Access Denied
        </h1>

        {/* Description */}
        <p className="mt-3 text-sm leading-6 text-gray-600">
          You are not an authorized person
          to access this page.
        </p>

        <p className="mt-2 text-sm leading-6 text-gray-500">
          Please contact Support Team or the
          Developers Team.
        </p>

        {/* Buttons */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">

          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 rounded-lg border border-gray-200 px-5 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-50"
          >
            <ArrowLeft size={16} />
            Go Back
          </button>

          <button
            onClick={() => navigate("/admin/home")}
            className="inline-flex items-center gap-2 rounded-lg bg-[#01C37D] px-5 py-2.5 text-sm font-medium text-white transition hover:opacity-90"
          >
            <LifeBuoy size={16} />
            Go to Dashboard
          </button>

        </div>
        <p className="mt-4 text-sm leading-6 text-gray-400">
          Error: 404_NOT_ALLOWED
        </p>
      </div>

    </div>
  );
}